import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {API} from '@chekin/api';

function useFetchOffer({id}: {id: string}) {
  return useQuery({
    queryKey: [QUERY_CACHE_KEYS.offer, id],
    queryFn: () => API.upselling.getOffer(id),
    enabled: Boolean(id),
  });
}

export {useFetchOffer};
